import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useCustomAuth } from '@/contexts/CustomAuthContext';

// Reduz o nome completo a "primeiro + último" (descarta os nomes do meio)
function formatName(fullName: string) {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return null;
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1]}`;
}

export function HeaderGreeting() {
  useLanguage();
  const { user, isLoading } = useCustomAuth();
  const name = formatName(user?.nome || '');

  // Enquanto o contexto de auth hidrata não pintamos um nome errado:
  // mostra um skeleton discreto até o nome real chegar.
  const showSkeleton = !name && isLoading;

  return (
    <div className="flex flex-col justify-center min-w-0 mt-3">
      {showSkeleton ? (
        <div className="h-[26px] w-[190px] rounded-[6px] bg-[#E7ECF3] animate-pulse" />
      ) : (
        <h1 className="text-[24px] font-semibold leading-[1.1] tracking-[-0.01em] text-[#101828] truncate">
          {translateInterfaceText("Olá, {value0}", { value0: (name || 'Usuário') })}
        </h1>
      )}
      <span className="mt-[3px] text-[13px] font-normal leading-tight text-[#98A2B3] truncate">
        {translateInterfaceText("Que bom ter você por aqui")}</span>
    </div>
  );
}
